<div class="spinner-container">
    <div class="custom-spinner">
        <div class="spinner-blade" *ngFor="let blade of blades"></div>
    </div>
</div>